import { defineComponent as _defineComponent } from 'vue'
import BCXButton from '@/components/molecules/BCXButton.vue';
import useI18n from '@/mixins/useI18n';
import MarvinInfoBox from '@/views/recommendations/components/MarvinInfoBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectActionApplyMaxOffersReached',
  emits: ['continue'],
  setup(__props, { emit }) {



const { t } = useI18n();


return { __sfc: true,emit, t, BCXButton, MarvinInfoBox }
}

})